import { render, staticRenderFns } from "./DocketFileNumber.vue?vue&type=template&id=fef2d708"
import script from "./DocketFileNumber.vue?vue&type=script&lang=js"
export * from "./DocketFileNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports